/**
 * Controla a exibição do aviso de mudança de taxas.
 * Ao anunciar uma nova mudança, incremente o sufixo da chave para que o aviso
 * volte a aparecer para quem já havia fechado o anterior.
 */
const FEE_CHANGE_NOTICE_LOCAL_STORAGE_KEY = 'show-fee-change-notice-2026-08';

export const getFeeChangeNoticeStatus = () => {
  if (typeof localStorage === 'undefined') return false;

  return localStorage.getItem(FEE_CHANGE_NOTICE_LOCAL_STORAGE_KEY) !== 'false';
};

export const hideFeeChangeNotice = () => {
  if (typeof localStorage === 'undefined') return;

  localStorage.setItem(FEE_CHANGE_NOTICE_LOCAL_STORAGE_KEY, 'false');
};
